var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checkmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Action-/-Details-/-Raisefund",
    transform: "translate(-369.000000, -887.000000)",
    fill: "#00B46E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "action",
    transform: "translate(0.000000, 175.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "raisefund",
    transform: "translate(363.000000, 546.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4305646,178 C11.1750099,178 10.919233,177.898923 10.7239004,177.696307 L6.29347148,173.102142 C5.90258397,172.69691 5.90213952,172.039447 6.29236038,171.633523 C6.68258123,171.22783 7.31591234,171.227369 7.70657764,171.6326 L11.4305646,175.494071 L20.2934224,166.303895 C20.6840877,165.898202 21.3171965,165.898894 21.7076396,166.304818 C22.0978605,166.710742 22.097416,167.368205 21.7065285,167.773437 L12.1372288,177.696307 C11.9418961,177.898923 11.6861192,178 11.4305646,178",
    id: "checkmark"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.7133027b404d33f7d3ac03f030f18086.svg";
export { ForwardRef as ReactComponent };